import { Directive, ElementRef, Output, EventEmitter, HostListener } from '@angular/core';

@Directive({
	selector: '[appClickOutside]',
	standalone: false,
})
export class ClickOutsideDirective {
	@Output() appClickOutside = new EventEmitter();

	constructor(private elementRef: ElementRef) { }

	@HostListener('document:click', ['$event.target'])
	onClick(targetElement: any) {
		const clickedInside = this.elementRef.nativeElement.contains(targetElement);
		if (!clickedInside) {
	  this.appClickOutside.emit();
		}
	}
}
